import * as React from 'react';
import { isNull } from 'util';
import { FormControl } from 'react-bootstrap';
import * as ControlLabel from 'react-bootstrap/lib/ControlLabel';
import * as FormGroup from 'react-bootstrap/lib/FormGroup';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';

export interface SelectComponentProps {
  label?: string;
  defaultValue?: string;
  value?: string;
  options: { name: string; value: string; }[];
  addEmptyOption: boolean;
  handleChange: (value: string) => void;
  className?: string;
}

const SelectComponent = (props: SelectComponentProps) => {
  if (isNull(props.options)) {
    return <LoadingContainer/>;
  }

  return (
    <FormGroup
      controlId="formControlsSelect"
      className={props.className ? props.className : ''}
    >
      {props.label ?
        <ControlLabel>{props.label}</ControlLabel> : null
      }
      {props.value ?
        <FormControl
          componentClass="select"
          value={props.value}
          onChange={(e) => props.handleChange((e.target as HTMLInputElement).value)}
        >
          {props.addEmptyOption ?
            <option value=""/> : null
          }
          {props.options.map((option, index) => {
            return (
              <option
                key={index}
                value={option.name}
              >
                {option.value}
              </option>
            );
          })}
        </FormControl> :
        <FormControl
          componentClass="select"
          defaultValue={props.defaultValue || ''}
          onChange={(e) => props.handleChange((e.target as HTMLInputElement).value)}
        >
          {props.addEmptyOption ?
            <option value=""/> : null
          }
          {props.options.map((option, index) => {
            return (
              <option
                key={index}
                value={option.name}
              >
                {option.value}
              </option>
            );
          })}
        </FormControl>
      }
    </FormGroup>
  );
};

export default SelectComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/inputs/bootstrap-select/Select.component.tsx